import { StyledTag } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Stack, Typography } from '@mui/material';
import { memo } from 'react';
import {
  getPaymentMethodLogoConfig,
  PaymentMethodLogo,
} from '../payment-method-logo';
import * as Styled from './styles';
import * as SX from './sx';
import type { PaymentCardInfoProps as Props } from './types';

export const PaymentCardInfo = memo(
  ({ className, item, isPaymentMethod, iconType }: Props) => {
    const { label } = getPaymentMethodLogoConfig(iconType);

    const expiryLabel =
      item?.expMonth && item?.expYear
        ? `VALID THRU ${String(item.expMonth).padStart(2, '0')} /${item.expYear
            .toString()
            .slice(-2)}`
        : null;

    return (
      <Styled.Wrapper
        className={classnames('PaymentCardInfo', className)}
        sx={SX.root({ isPaymentMethod })}
      >
        <PaymentMethodLogo iconType={iconType} />
        <Stack gap={isPaymentMethod ? 0 : 0.5} flex={1} minWidth={0}>
          <Stack
            direction="row"
            justifyContent={isPaymentMethod ? 'flex-start' : 'space-between'}
            alignItems="center"
            gap={isPaymentMethod ? 1.5 : 0}
          >
            <Typography
              variant={isPaymentMethod ? 'body2' : 'body4'}
              fontWeight={700}
              color={isPaymentMethod ? 'grey.700' : 'grey.600'}
            >
              {label}
            </Typography>
            {expiryLabel && (
              <StyledTag
                variant="outlined"
                color="warning"
                label={expiryLabel}
                size={isPaymentMethod ? 'xsmall' : 'small'}
              />
            )}
          </Stack>
          <Typography
            variant={isPaymentMethod ? 'body5' : 'body4'}
            fontWeight={isPaymentMethod ? 500 : 400}
            color={isPaymentMethod ? 'grey.500' : 'grey.600'}
            paddingTop={isPaymentMethod ? 1 : 0}
          >
            **** **** **** {item?.last4 ?? '****'}
          </Typography>
        </Stack>
      </Styled.Wrapper>
    );
  }
);

PaymentCardInfo.displayName = 'PaymentCardInfo';
